import type { Plugin } from 'vue'

import {
  LlAdvancedFiltering,
  LlAdvancedFilteringParams,
  LlAdvancedFilteringTags,
  LlApiComponent,
  LlAudioPlayer,
  LlAutoComplete,
  LlAvatar,
  LlAvatarGroup,
  LlBackTop,
  LlBadge,
  LlBarcode,
  LlBreadcrumb,
  LlBreadcrumbCard,
  LlButton,
  LlButtonGroup,
  LlCalendar,
  LlCascader,
  LlCheckableTag,
  LlCheckbox,
  LlCheckboxGroup,
  LlCodeEditor,
  LlCodemirrorEditorVue3,
  LlCollapse,
  LlCollapsePanel,
  LlColorPicker,
  LlColorPresetPicker,
  LlColumnManager,
  LlConfigProvider,
  LlCopyText,
  LlCountdown,
  LlCronExpressionBuilder,
  LlCropperImage,
  LlCropperModal,
  LlCustomSearcher,
  LlCustomSorter,
  LlDatePicker,
  LlDateRange,
  LlDescriptions,
  LlDescriptionsItem,
  LlDivider,
  LlDrawer,
  LlDropdown,
  LlDropdownButton,
  LlDropdownButtonSimple,
  LlEmailInput,
  LlEmpty,
  LlFlexSplitLayout,
  LlFloatButton,
  LlFloatButtonGroup,
  LlForm,
  LlFormItem,
  LlGantt,
  LlGroupTitle,
  LlHeatmap,
  LlHtml,
  LlIcon,
  LlIconBase,
  LlIconBasePro,
  LlIconPicker,
  LlIframe,
  LlImage,
  LlImagePreviewGroup,
  LlInlineStepper,
  LlInput,
  LlInputNumber,
  LlInputSearch,
  LlKeyValue,
  LlLink,
  LlMarkdownEditor,
  LlMarkdownPreviewer,
  LlMarqueePro,
  LlModal,
  LlModalOverlay,
  LlNewDrawer,
  LlNewModal,
  LlNumberRange,
  LlOperateIcon,
  LlOperateTree,
  LlPagination,
  LlPaginationPro,
  LlPasswordInput,
  LlProTable,
  LlProgressBar,
  LlQrcode,
  LlRadio,
  LlRadioButton,
  LlRadioGroup,
  LlRankingList,
  LlRate,
  LlRichTextEditor,
  LlSecondConfirmation,
  LlSegmented,
  LlSelect,
  LlSelectGroup,
  LlSelectOptGroup,
  LlSelectOption,
  LlSignature,
  LlSlider,
  LlSlideshow,
  LlSortSelector,
  LlSpace,
  LlStatistic,
  LlStatisticCountdown,
  LlStepItem,
  LlSteps,
  LlSwitch,
  LlTable,
  LlTabs,
  LlTag,
  LlTagCatalog,
  LlTagGroup,
  LlText,
  LlTextParagraph,
  LlTextarea,
  LlTimePicker,
  LlTimeRange,
  LlTimeline,
  LlTimelineItem,
  LlTooltip,
  LlTree,
  LlTreeSearch,
  LlTreeSelect,
  LlTrend,
  LlUpload,
  LlUploadDrag,
  LlUploadImage,
  LlUriInput,
  LlVerticalLayout,
  LlVideoPlayer,
  LlWatermark,
} from '@ll-plus/components'

export default [
  LlAdvancedFiltering,
  LlAdvancedFilteringParams,
  LlAdvancedFilteringTags,
  LlApiComponent,
  LlAudioPlayer,
  LlAutoComplete,
  LlAvatar,
  LlAvatarGroup,
  LlBackTop,
  LlBadge,
  LlBarcode,
  LlBreadcrumb,
  LlBreadcrumbCard,
  LlButton,
  LlButtonGroup,
  LlCalendar,
  LlCascader,
  LlCheckableTag,
  LlCheckbox,
  LlCheckboxGroup,
  LlCodeEditor,
  LlCodemirrorEditorVue3,
  LlCollapse,
  LlCollapsePanel,
  LlColumnManager,
  LlColorPicker,
  LlColorPresetPicker,
  LlConfigProvider,
  LlCopyText,
  LlCropperImage,
  LlCropperModal,
  LlCustomSearcher,
  LlCustomSorter,
  LlCountdown,
  LlDatePicker,
  LlDateRange,
  LlDescriptions,
  LlDescriptionsItem,
  LlDivider,
  LlFlexSplitLayout,
  LlDrawer,
  LlDropdown,
  LlDropdownButton,
  LlDropdownButtonSimple,
  LlNewDrawer,
  LlCronExpressionBuilder,
  LlEmailInput,
  LlEmpty,
  LlFloatButton,
  LlFloatButtonGroup,
  LlForm,
  LlFormItem,
  LlGroupTitle,
  LlHeatmap,
  LlGantt,
  LlIcon,
  LlHtml,
  LlIconBase,
  LlIconBasePro,
  LlIconPicker,
  LlIframe,
  LlImage,
  LlInlineStepper,
  LlImagePreviewGroup,
  LlInput,
  LlPasswordInput,
  LlInputSearch,
  LlInputNumber,
  LlKeyValue,
  LlVerticalLayout,
  LlLink,
  LlMarkdownEditor,
  LlMarkdownPreviewer,
  LlMarqueePro,
  LlModal,
  LlModalOverlay,
  LlNewModal,
  LlNumberRange,
  LlOperateIcon,
  LlOperateTree,
  LlPaginationPro,
  LlProTable,
  LlProgressBar,
  LlQrcode,
  LlRadio,
  LlRadioButton,
  LlRadioGroup,
  LlRankingList,
  LlRate,
  LlRichTextEditor,
  LlSecondConfirmation,
  LlSegmented,
  LlSelect,
  LlSelectOption,
  LlSelectOptGroup,
  LlSelectGroup,
  LlSignature,
  LlSlider,
  LlSlideshow,
  LlSortSelector,
  LlSpace,
  LlStatistic,
  LlStatisticCountdown,
  LlSteps,
  LlStepItem,
  LlSwitch,
  LlTable,
  LlPagination,
  LlTabs,
  LlTag,
  LlTagCatalog,
  LlTagGroup,
  LlTextarea,
  LlTimePicker,
  LlTimeRange,
  LlTimeline,
  LlTimelineItem,
  LlTooltip,
  LlTreeSearch,
  LlTreeSelect,
  LlTree,
  LlTrend,
  LlText,
  LlTextParagraph,
  LlUpload,
  LlUploadDrag,
  LlUploadImage,
  LlUriInput,
  LlVideoPlayer,
  LlWatermark,
] as Plugin[]
